export default __webpack_public_path__ + "static/media/Project-5-PortfolioPage-MainImg.1aa4aba6.png";